import PaymentPurpose from './PaymentPurpose';

export default PaymentPurpose;
